import { isBoolean, isObject } from '@guardian/libs';
import { getOptionsHeadersWithOkta } from '../../lib/identity';
import { fetchJson } from './fetchJson';
const dates = {
    1: '01',
    2: '02',
    3: '03',
    4: '04',
    5: '05',
    6: '06',
    7: '07',
    8: '08',
    9: '09',
    10: '10',
    11: '11',
    12: '12',
    13: '13',
    14: '14',
    15: '15',
    16: '16',
    17: '17',
    18: '18',
    19: '19',
    20: '20',
    21: '21',
    22: '22',
    23: '23',
    24: '24',
    25: '25',
    26: '26',
    27: '27',
    28: '28',
    29: '29',
    30: '30',
    31: '31',
};
const months = {
    1: '01',
    2: '02',
    3: '03',
    4: '04',
    5: '05',
    6: '06',
    7: '07',
    8: '08',
    9: '09',
    10: '10',
    11: '11',
    12: '12',
};
export const syncDataFromMembersDataApi = async (signedInAuthStatus) => {
    const response = await fetchJson(`${window.guardian.config.page.userAttributesApiUrl ??
        '/USER_ATTRIBUTE_API_NOT_FOUND'}/me`, {
        mode: 'cors',
        ...getOptionsHeadersWithOkta(signedInAuthStatus),
    });
    if (!validateResponse(response)) {
        throw new Error('invalid response');
    }
    return {
        hideSupportMessaging: !response.showSupportMessaging,
        adFree: response.contentAccess.digitalPack,
    };
};
const validateResponse = (response) => {
    return (isObject(response) &&
        isBoolean(response.showSupportMessaging) &&
        isObject(response.contentAccess) &&
        isBoolean(response.contentAccess.paidMember) &&
        isBoolean(response.contentAccess.recurringContributor) &&
        isBoolean(response.contentAccess.digitalPack));
};
